/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/dist";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(1);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(39);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var win = window;
	var Monitor = __webpack_require__(41);
	var monitor = new Monitor();
	var oldOnErrorHandler = win.onerror;
	var oldOnBeforeUnloadHandler = win.onbeforeunload;
	var queue = [];
	var pushCount = {};
	var pushTimer = null;
	
	var recentClickEventList = [];
	var recentAjaxList = [];
	
	win.monitor = monitor;
	
	monitor.vuePlugin = {
	  install: function install(Vue, options) {
	    var errorHandler = Vue.config.errorHandler;
	    Vue.config.errorHandler = function (error) {
	      error = error || {};
	      error.stack = error.stack;
	      error.message = error.message;
	      collect(error, error.message + (0, _stringify2.default)(error.stack));
	      call(errorHandler, arguments, win);
	      throw error;
	    };
	  }
	};
	
	win.onclick = function (e) {
	  var onClickEvent = (0, _assign2.default)({}, {
	    innerText: e.target.innerText,
	    pageX: e.pageX,
	    pageY: e.pageY,
	    type: e.type,
	    outerHTML: e.target.outerHTML,
	    timestamp: new Date().toLocaleString(),
	    url: location.href || '',
	    title: document.title || ''
	  });
	  if (recentClickEventList.length > 10) {
	    recentClickEventList.shift();
	  }
	  recentClickEventList.push(onClickEvent);
	};
	
	win.onerror = function (message, fileName, lineNumber, columnNumber, error) {
	  var _arguments = arguments;
	
	  setTimeout(function () {
	    error = error || {};
	    error.message = error.message || message || '';
	    error.fileName = fileName.split(' ')[0];
	    error.lineNumber = lineNumber;
	    error.columnNumber = columnNumber;
	    error.recentClickEventList = recentClickEventList;
	    error.recentAjaxList = recentAjaxList;
	    collect(error, '' + error.message + error.fileName + error.lineNumber + error.columnNumber);
	    call(oldOnErrorHandler, _arguments, win);
	  }, 0);
	};
	
	win.onbeforeunload = function () {
	  push();
	  call(oldOnBeforeUnloadHandler, arguments, win);
	};
	
	go();
	
	function collect(error, key) {
	  pushCount[key] = pushCount[key] || 0;
	  if (pushCount[key] < monitor._config.repeat) {
	    pushCount[key]++;
	    queue.push(error);
	  }
	}
	
	function push() {
	  for (var i = 0; i < queue.length; i++) {
	    monitor.push(queue[i]);
	  }
	  queue = [];
	}
	
	function go() {
	  pushTimer = setTimeout(function () {
	    push();
	    go();
	  }, monitor._config.interval);
	}
	
	function call(fun, args, context) {
	  if (typeof fun === 'function') {
	    fun.apply(context, args);
	  }
	}
	
	var open = window.XMLHttpRequest.prototype.open,
	    send = window.XMLHttpRequest.prototype.send,
	    onReadyStateChange;
	
	function openReplacement(method, url, async, user, password) {
	  var syncMode = async !== false ? 'async' : 'sync';
	
	  return open.apply(this, arguments);
	}
	
	function sendReplacement(data) {
	  if (this.onreadystatechange) {
	    this._onreadystatechange = this.onreadystatechange;
	  }
	  this.onreadystatechange = onReadyStateChangeReplacement;
	
	  return send.apply(this, arguments);
	}
	
	function onReadyStateChangeReplacement() {
	  if (this.readyState === 4 && this.responseURL !== monitor._api) {
	    if (recentAjaxList.length === 10) {
	      recentAjaxList.shift();
	    }
	    recentAjaxList.push({
	      api: this.responseURL,
	      title: document.title,
	      url: location.href,
	      time: new Date().toLocaleString()
	    });
	  }
	  if (this._onreadystatechange) {
	    return this._onreadystatechange.apply(this, arguments);
	  }
	}
	
	window.XMLHttpRequest.prototype.open = openReplacement;
	window.XMLHttpRequest.prototype.send = sendReplacement;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2), __esModule: true };

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(3);
	module.exports = __webpack_require__(6).Object.assign;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(4);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(20) });


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var core = __webpack_require__(6);
	var ctx = __webpack_require__(7);
	var hide = __webpack_require__(9);
	var has = __webpack_require__(19);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.10' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(8);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(10);
	var createDesc = __webpack_require__(18);
	module.exports = __webpack_require__(14) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(11);
	var IE8_DOM_DEFINE = __webpack_require__(13);
	var toPrimitive = __webpack_require__(17);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(14) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(14) && !__webpack_require__(15)(function () {
	  return Object.defineProperty(__webpack_require__(16)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(15)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	var document = __webpack_require__(5).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(12);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(14);
	var getKeys = __webpack_require__(21);
	var gOPS = __webpack_require__(36);
	var pIE = __webpack_require__(37);
	var toObject = __webpack_require__(38);
	var IObject = __webpack_require__(24);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(15)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(22);
	var enumBugKeys = __webpack_require__(35);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(19);
	var toIObject = __webpack_require__(23);
	var arrayIndexOf = __webpack_require__(27)(false);
	var IE_PROTO = __webpack_require__(31)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(24);
	var defined = __webpack_require__(26);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(25);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(23);
	var toLength = __webpack_require__(28);
	var toAbsoluteIndex = __webpack_require__(30);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(29);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(29);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(32)('keys');
	var uid = __webpack_require__(34);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(6);
	var global = __webpack_require__(5);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(33) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(26);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(6);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(39);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stackparser = __webpack_require__(42);
	function Monitor() {
	  this._api = ("https://fem.finupgroup.com/api") + '/push';
	  this._handlers = {};
	  this._config = {
	    ignore: {},
	    interval: 1 * 1000,
	    repeat: 5,
	    email: false,
	    defaulteValues: {
	      errorType: 'js',
	      errorLevel: 1,
	      projectName: location.hostname || location.host
	    }
	  };
	}
	
	var fn = Monitor.prototype;
	
	fn.config = function (option) {
	  option = option || {};
	  for (var key in option) {
	    if (key == 'ignore' || key == 'defaulteValues') {
	      for (var key in option[key]) {
	        this._config[key][key2] = option[key][key2];
	      }
	    } else {
	      this._config[key] = option[key];
	    }
	  }
	  return this;
	};
	
	fn.push = function (error) {
	  var ignore = false;
	  var self = this;
	  error = this._parse(error);
	
	  if (error) {
	    for (var key in this._config.ignore) {
	      var field = this._config.ignore[key];
	      if (typeof field === 'string') {
	        if (field === error[key]) {
	          ignore = true;
	          break;
	        }
	      } else {
	        if (field.test(error[key])) {
	          ignore = true;
	          break;
	        }
	      }
	    }
	    if (!ignore) {
	      var event = 'beforePush';
	      if (this._handlers[event] && this._handlers[event].length) {
	        this.emit(event, [error, function next(continueErrorInfo) {
	          if (!next.__called) {
	            self._request(self._setEmail(continueErrorInfo || error));
	            next.__called = true;
	          }
	        }]);
	      } else {
	        self._request(this._setEmail(error));
	      }
	    }
	  }
	  return this;
	};
	
	fn.watch = function (fun, context) {
	  var self = this;
	  fun = fun || function () {};
	  if (!fun.__wraper) {
	    fun.__wraper = function () {
	      try {
	        fun.apply(context || this, arguments);
	      } catch (e) {
	        self.push(e);
	        throw e;
	      }
	    };
	  }
	  return fun.__wraper;
	};
	
	fn._setEmail = function (error) {
	  if (this._config.email) {
	    error.email = typeof this._config.email === 'function' ? this._config.email(error) : this._config.email;
	  }
	  return error;
	};
	
	fn._parse = function (error) {
	  var stack = error.stack ? stackparser.parse(error) : '';
	  var defaulteValues = this._config.defaulteValues;
	  var obj = {
	    name: error.name,
	    title: error.title || document.title,
	    projectName: defaulteValues.projectName,
	    host: location.hostname,
	    message: error.message || error.description,
	    content: error.message || error.description,
	    errorType: error.errorType || 'js',
	    url: error.url || location.href,
	    errorLevel: error.errorLevel || defaulteValues.errorLevel,
	    requestUrl: error.requestUrl,
	    requestMethod: error.requestMethod,
	    responseStatusCode: error.responseStatusCode,
	    responseStatusText: error.responseStatusText,
	    response: error.response,
	    stack: stack,
	    lineNumber: error.lineNumber || error.line || stack && stack[0].lineNumber,
	    columnNumber: error.columnNumber || error.column || stack && stack[0].columnNumber,
	    fileName: error.fileName || stack && stack[0].fileName,
	    recentClickEventList: error.recentClickEventList || null,
	    recentAjaxList: error.recentAjaxList || null,
	    cookies: document.cookie || null
	  };
	
	  return obj;
	};
	
	fn._request = function (error) {
	  var self = this;
	  var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
	  xhr.responseType = 'json';
	  xhr.onreadystatechange = function () {
	    if (xhr.readyState == 4) {
	      if (xhr.status == 200 && xhr.response.code == '00000') {
	        self.emit('pushSuccess', [error]);
	      } else {
	        self.emit('pushFailed', [error]);
	      }
	      self.emit('completePush', [error]);
	    }
	  };
	  xhr.open('POST', this._api, true);
	  xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
	  xhr.send((0, _stringify2.default)(error));
	};
	
	fn.on = function (event, callback) {
	  if (!this._handlers[event]) {
	    this._handlers[event] = [];
	  }
	  var callbacks = this._handlers[event];
	  for (var i = 0; i <= callbacks.length; i++) {
	    if (callback == callbacks[i]) {
	      return this;
	    }
	  }
	  this._handlers[event].push(callback);
	  return this;
	};
	
	fn.emit = function (event, args) {
	  if (this._handlers[event] && this._handlers[event].length) {
	    var callbacks = this._handlers[event];
	    for (var i = 0; i <= callbacks.length; i++) {
	      if (typeof callbacks[i] == 'function') {
	        callbacks[i].apply(this, args);
	      }
	    }
	  }
	  return this;
	};
	
	fn.off = function (event, callback) {
	  if (!this._handlers[event] || !this._handlers[event].length) {
	    return this;
	  }
	  if (callback) {
	    var callbacks = this._handlers[event];
	    for (var i = 0; i <= callbacks.length; i++) {
	      if (callbacks[i] == callback) {
	        callbacks.splice(i, 1);
	        return this;
	      }
	    }
	  }
	  return this;
	};
	
	module.exports = Monitor;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var StackFrame = __webpack_require__(43);
	
	module.exports = function ErrorStackParser(StackFrame) {
	  'use strict';
	
	  var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
	  var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
	  var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
	
	  return {
	    parse: function ErrorStackParser$$parse(error) {
	      if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
	        return this.parseOpera(error);
	      } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
	        return this.parseV8OrIE(error);
	      } else if (error.stack) {
	        return this.parseFFOrSafari(error);
	      } else {
	        throw new Error('Cannot parse given Error object');
	      }
	    },
	
	    extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
	      if (urlLike.indexOf(':') === -1) {
	        return [urlLike];
	      }
	
	      var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
	      var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
	      return [parts[1], parts[2] || undefined, parts[3] || undefined];
	    },
	
	    parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
	      var filtered = error.stack.split('\n').filter(function (line) {
	        return !!line.match(CHROME_IE_STACK_REGEXP);
	      }, this);
	
	      return filtered.map(function (line) {
	        if (line.indexOf('(eval ') > -1) {
	          line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
	        }
	        var tokens = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').split(/\s+/).slice(1);
	        var locationParts = this.extractLocation(tokens.pop());
	        var functionName = tokens.join(' ') || undefined;
	        var fileName = ['eval', '<anonymous>'].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
	
	        return new StackFrame({
	          functionName: functionName,
	          fileName: fileName,
	          lineNumber: locationParts[1],
	          columnNumber: locationParts[2],
	          source: line
	        });
	      }, this);
	    },
	
	    parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
	      var filtered = error.stack.split('\n').filter(function (line) {
	        return !line.match(SAFARI_NATIVE_CODE_REGEXP);
	      }, this);
	
	      return filtered.map(function (line) {
	        if (line.indexOf(' > eval') > -1) {
	          line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
	        }
	
	        if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
	          return new StackFrame({
	            functionName: line
	          });
	        } else {
	          var tokens = line.split('@');
	          var locationParts = this.extractLocation(tokens.pop());
	          var functionName = tokens.join('@') || undefined;
	
	          return new StackFrame({
	            functionName: functionName,
	            fileName: locationParts[0],
	            lineNumber: locationParts[1],
	            columnNumber: locationParts[2],
	            source: line
	          });
	        }
	      }, this);
	    },
	
	    parseOpera: function ErrorStackParser$$parseOpera(e) {
	      if (!e.stacktrace || e.message.indexOf('\n') > -1 && e.message.split('\n').length > e.stacktrace.split('\n').length) {
	        return this.parseOpera9(e);
	      } else if (!e.stack) {
	        return this.parseOpera10(e);
	      } else {
	        return this.parseOpera11(e);
	      }
	    },
	
	    parseOpera9: function ErrorStackParser$$parseOpera9(e) {
	      var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
	      var lines = e.message.split('\n');
	      var result = [];
	
	      for (var i = 2, len = lines.length; i < len; i += 2) {
	        var match = lineRE.exec(lines[i]);
	        if (match) {
	          result.push(new StackFrame({
	            fileName: match[2],
	            lineNumber: match[1],
	            source: lines[i]
	          }));
	        }
	      }
	
	      return result;
	    },
	
	    parseOpera10: function ErrorStackParser$$parseOpera10(e) {
	      var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
	      var lines = e.stacktrace.split('\n');
	      var result = [];
	
	      for (var i = 0, len = lines.length; i < len; i += 2) {
	        var match = lineRE.exec(lines[i]);
	        if (match) {
	          result.push(new StackFrame({
	            functionName: match[3] || undefined,
	            fileName: match[2],
	            lineNumber: match[1],
	            source: lines[i]
	          }));
	        }
	      }
	
	      return result;
	    },
	
	    parseOpera11: function ErrorStackParser$$parseOpera11(error) {
	      var filtered = error.stack.split('\n').filter(function (line) {
	        return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
	      }, this);
	
	      return filtered.map(function (line) {
	        var tokens = line.split('@');
	        var locationParts = this.extractLocation(tokens.pop());
	        var functionCall = tokens.shift() || '';
	        var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^\)]*\)/g, '') || undefined;
	        var argsRaw;
	        if (functionCall.match(/\(([^\)]*)\)/)) {
	          argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
	        }
	        var args = argsRaw === undefined || argsRaw === '[arguments not available]' ? undefined : argsRaw.split(',');
	
	        return new StackFrame({
	          functionName: functionName,
	          args: args,
	          fileName: locationParts[0],
	          lineNumber: locationParts[1],
	          columnNumber: locationParts[2],
	          source: line
	        });
	      }, this);
	    }
	  };
	}(StackFrame);

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function () {
	  'use strict';
	
	  function _isNumber(n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	  }
	
	  function _capitalize(str) {
	    return str.charAt(0).toUpperCase() + str.substring(1);
	  }
	
	  function _getter(p) {
	    return function () {
	      return this[p];
	    };
	  }
	
	  var booleanProps = ['isConstructor', 'isEval', 'isNative', 'isToplevel'];
	  var numericProps = ['columnNumber', 'lineNumber'];
	  var stringProps = ['fileName', 'functionName', 'source'];
	  var arrayProps = ['args'];
	
	  var props = booleanProps.concat(numericProps, stringProps, arrayProps);
	
	  function StackFrame(obj) {
	    if (obj instanceof Object) {
	      for (var i = 0; i < props.length; i++) {
	        if (obj.hasOwnProperty(props[i]) && obj[props[i]] !== undefined) {
	          this['set' + _capitalize(props[i])](obj[props[i]]);
	        }
	      }
	    }
	  }
	
	  StackFrame.prototype = {
	    getArgs: function getArgs() {
	      return this.args;
	    },
	    setArgs: function setArgs(v) {
	      if (Object.prototype.toString.call(v) !== '[object Array]') {
	        throw new TypeError('Args must be an Array');
	      }
	      this.args = v;
	    },
	
	    getEvalOrigin: function getEvalOrigin() {
	      return this.evalOrigin;
	    },
	    setEvalOrigin: function setEvalOrigin(v) {
	      if (v instanceof StackFrame) {
	        this.evalOrigin = v;
	      } else if (v instanceof Object) {
	        this.evalOrigin = new StackFrame(v);
	      } else {
	        throw new TypeError('Eval Origin must be an Object or StackFrame');
	      }
	    },
	
	    toString: function toString() {
	      var functionName = this.getFunctionName() || '{anonymous}';
	      var args = '(' + (this.getArgs() || []).join(',') + ')';
	      var fileName = this.getFileName() ? '@' + this.getFileName() : '';
	      var lineNumber = _isNumber(this.getLineNumber()) ? ':' + this.getLineNumber() : '';
	      var columnNumber = _isNumber(this.getColumnNumber()) ? ':' + this.getColumnNumber() : '';
	      return functionName + args + fileName + lineNumber + columnNumber;
	    }
	  };
	
	  for (var i = 0; i < booleanProps.length; i++) {
	    StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
	    StackFrame.prototype['set' + _capitalize(booleanProps[i])] = function (p) {
	      return function (v) {
	        this[p] = Boolean(v);
	      };
	    }(booleanProps[i]);
	  }
	
	  for (var j = 0; j < numericProps.length; j++) {
	    StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
	    StackFrame.prototype['set' + _capitalize(numericProps[j])] = function (p) {
	      return function (v) {
	        if (!_isNumber(v)) {
	          throw new TypeError(p + ' must be a Number');
	        }
	        this[p] = Number(v);
	      };
	    }(numericProps[j]);
	  }
	
	  for (var k = 0; k < stringProps.length; k++) {
	    StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
	    StackFrame.prototype['set' + _capitalize(stringProps[k])] = function (p) {
	      return function (v) {
	        this[p] = String(v);
	      };
	    }(stringProps[k]);
	  }
	
	  return StackFrame;
	}();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// monitor.js